module.exports = __webpack_public_path__ + "img/checked-in-participant-icon.72dc42ab.svg";